import { Turbo } from "@hotwired/turbo-rails"
window.Turbo = Turbo

import "controllers"

// Import inline editing functionality
import "../tetherx/inline_edit.js"
